let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hjAQK")).then(() => parcelRequire('3zK2p'));